import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../../../globals";
import { DishServices } from "../../../services";

@Component({
    selector: 'page-dish-partial-tags',
    templateUrl: 'dish-partial-tags.html',
})
export class DishPartialTagsPage {
    show_dish_tags = false;
    dish_tags_filtered = [];

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals,
        public dishServices: DishServices) {
    }

    onChange(val) {
        this.dishServices.dish_tags = val || [];
    }

    addTag(tag) {
        // Asegurar que dish_tags sea un array
        if (!this.dishServices.dish_tags) {
            this.dishServices.dish_tags = [];
        }
        
        if (!(this.dishServices.dish_tags.indexOf(tag) > -1)) {
            if (tag != 'eti') {
                this.dishServices.dish_tags.push(tag);
                this.show_dish_tags = false;
                this.dish_tags_filtered = [];
            }
        }
    }

    onInputChange(event: any) {
        const valorInput = event.target.value;
        if (valorInput) {
            this.show_dish_tags = true;
            this.dish_tags_filtered = this.globals.tags_all.filter(tag =>
                tag.toLowerCase().includes(valorInput.toLowerCase()));
            this.dish_tags_filtered.sort((one, two) => (one.toLowerCase() < two.toLowerCase() ? -1 : 1));
        } else {
            this.show_dish_tags = false;
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/dish/dish-create/dish-create-name/dish-partial-tags/dish-partial-tags.ts